import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useUser } from "../lib/userAuth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { refresh } = useUser();
  const handled = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    const next = params.get("next") || "/";

    if (!sessionId) {
      nav(next, { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google-session", { session_id: sessionId });
        // Clear the hash before continuing
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        await refresh();
        nav(next, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Sign-in failed. Please try again.");
      }
    })();
  }, [nav, params, refresh]);

  return (
    <main className="min-h-screen flex items-center justify-center p-8">
      <div className="text-center" data-testid="auth-callback">
        {error ? (
          <p className="text-red-600 font-semibold">{error}</p>
        ) : (
          <>
            <div className="w-8 h-8 border-2 border-stone-900 border-t-transparent rounded-full mx-auto animate-spin" />
            <p className="mt-4 text-stone-600">Signing you in…</p>
          </>
        )}
      </div>
    </main>
  );
}
